'use strict';

/*
 * warriors-carousel.js
 * Slide carousel for the Warriors Hero Carousel section.
 * Config is read from a data attribute on the carousel element:
 *   data-autoplay-ms="6000"
 */

(function () {
  var carousel = document.querySelector('[data-warriors-carousel]');
  if (!carousel) return;

  var autoplayMs    = parseInt(carousel.getAttribute('data-autoplay'), 10) || 6000;
  var track         = carousel.querySelector('[data-carousel-track]');
  var slides        = carousel.querySelectorAll('[data-carousel-slide]');
  var dotsContainer = carousel.querySelector('[data-carousel-dots]');
  var prevBtn       = carousel.querySelector('[data-carousel-prev]');
  var nextBtn       = carousel.querySelector('[data-carousel-next]');
  var total         = slides.length;
  var current       = 0;
  var autoplayTimer;

  if (!track || !total) return;

  // Build dots
  if (dotsContainer && total > 1) {
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'warriors-carousel__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.dataset.index = i;
      dotsContainer.appendChild(dot);
    }
  }

  function manageVideos() {
    slides.forEach(function (slide, i) {
      var vid = slide.querySelector('video');
      if (!vid) return;
      if (i === current) {
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        vid.pause();
      }
    });
  }

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    if (dotsContainer) {
      dotsContainer.querySelectorAll('.warriors-carousel__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }
    manageVideos();
  }

  if (dotsContainer) {
    dotsContainer.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-index]');
      if (dot) { goTo(parseInt(dot.dataset.index, 10)); resetAutoplay(); }
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetAutoplay(); });

  function startAutoplay() {
    autoplayTimer = setInterval(function () { goTo(current + 1); }, autoplayMs);
  }

  function stopAutoplay()  { clearInterval(autoplayTimer); }
  function resetAutoplay() { stopAutoplay(); startAutoplay(); }

  // Play the first slide's video explicitly — mobile browsers often ignore
  // the `autoplay` attribute and require a programmatic .play() call.
  manageVideos();

  // Pause/resume videos as the carousel scrolls in and out of the viewport.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          manageVideos();
        } else {
          slides.forEach(function (slide) {
            var vid = slide.querySelector('video');
            if (vid) vid.pause();
          });
        }
      });
    }, { threshold: 0.25 }).observe(carousel);
  }

  if (total > 1) {
    startAutoplay();
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    // Touch support
    var touchStartX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); resetAutoplay(); }
    });
  }

}());
